import React, { useState, useEffect } from 'react'
import { LessIcon, MoreIcon } from '../utils/icons'
import './CantidadComponent.scss'

const CantidadComponent = (props) => {
    const { numberInit, onClick } = props
    const [numero, setNumero] = useState(props.numberInit)

    useEffect(() => {
        setNumero(numberInit)
    }, [props])

    const handleAdd = () => {
        onClick(numero + 1)
        setNumero(numero + 1)
    }

    const handleDel = () => {
        if (numero >= 2) {
            onClick(numero - 1)
            setNumero(numero - 1)
        }
    }

    return (
        <div className="cantidad-component">
            <div className="icon pointer menos" onClick={handleDel}><LessIcon size={30} /></div>
            <div className="numero"><p>{numero}</p></div>
            <div className="icon pointer mas" onClick={handleAdd}><MoreIcon size={30} /></div>
        </div>
    )
}


export default CantidadComponent